import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Dots = ({ color, ...rest }: Props) => {
  return (
    <Svg
      width={254}
      height={114}
      viewBox="0 0 254 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.55611 13.1122C10.177 13.1122 13.1122 10.177 13.1122 6.55611C13.1122 2.93527 10.177 0 6.55611 0C2.93527 0 0 2.93527 0 6.55611C0 10.177 2.93527 13.1122 6.55611 13.1122Z"
        fill={color}
      />
      <path
        d="M66.7783 13.1122C70.3991 13.1122 73.3344 10.177 73.3344 6.55611C73.3344 2.93527 70.3991 0 66.7783 0C63.1574 0 60.2222 2.93527 60.2222 6.55611C60.2222 10.177 63.1574 13.1122 66.7783 13.1122Z"
        fill={color}
      />
      <path
        d="M127 13.1122C130.621 13.1122 133.556 10.177 133.556 6.55611C133.556 2.93527 130.621 0 127 0C123.379 0 120.444 2.93527 120.444 6.55611C120.444 10.177 123.379 13.1122 127 13.1122Z"
        fill={color}
      />
      <path
        d="M187.222 13.1122C190.843 13.1122 193.778 10.177 193.778 6.55611C193.778 2.93527 190.843 0 187.222 0C183.601 0 180.666 2.93527 180.666 6.55611C180.666 10.177 183.601 13.1122 187.222 13.1122Z"
        fill={color}
      />
      <path
        d="M247.444 13.1122C251.065 13.1122 254 10.177 254 6.55611C254 2.93527 251.065 0 247.444 0C243.823 0 240.888 2.93527 240.888 6.55611C240.888 10.177 243.823 13.1122 247.444 13.1122Z"
        fill={color}
      />
      <path
        d="M6.55611 63.2533C10.177 63.2533 13.1122 60.318 13.1122 56.6972C13.1122 53.0764 10.177 50.1411 6.55611 50.1411C2.93527 50.1411 0 53.0764 0 56.6972C0 60.318 2.93527 63.2533 6.55611 63.2533Z"
        fill={color}
      />
      <path
        d="M66.7783 63.2533C70.3991 63.2533 73.3344 60.318 73.3344 56.6972C73.3344 53.0764 70.3991 50.1411 66.7783 50.1411C63.1574 50.1411 60.2222 53.0764 60.2222 56.6972C60.2222 60.318 63.1574 63.2533 66.7783 63.2533Z"
        fill={color}
      />
      <path
        d="M127 63.2533C130.621 63.2533 133.556 60.318 133.556 56.6972C133.556 53.0764 130.621 50.1411 127 50.1411C123.379 50.1411 120.444 53.0764 120.444 56.6972C120.444 60.318 123.379 63.2533 127 63.2533Z"
        fill={color}
      />
      <path
        d="M187.222 63.2533C190.843 63.2533 193.778 60.318 193.778 56.6972C193.778 53.0764 190.843 50.1411 187.222 50.1411C183.601 50.1411 180.666 53.0764 180.666 56.6972C180.666 60.318 183.601 63.2533 187.222 63.2533Z"
        fill={color}
      />
      <path
        d="M247.444 63.2533C251.065 63.2533 254 60.318 254 56.6972C254 53.0764 251.065 50.1411 247.444 50.1411C243.823 50.1411 240.888 53.0764 240.888 56.6972C240.888 60.318 243.823 63.2533 247.444 63.2533Z"
        fill={color}
      />
      <path
        d="M6.55611 113.394C10.177 113.394 13.1122 110.459 13.1122 106.838C13.1122 103.217 10.177 100.282 6.55611 100.282C2.93527 100.282 0 103.217 0 106.838C0 110.459 2.93527 113.394 6.55611 113.394Z"
        fill={color}
      />
      <path
        d="M66.7783 113.394C70.3991 113.394 73.3344 110.459 73.3344 106.838C73.3344 103.217 70.3991 100.282 66.7783 100.282C63.1574 100.282 60.2222 103.217 60.2222 106.838C60.2222 110.459 63.1574 113.394 66.7783 113.394Z"
        fill={color}
      />
      <path
        d="M127 113.394C130.621 113.394 133.556 110.459 133.556 106.838C133.556 103.217 130.621 100.282 127 100.282C123.379 100.282 120.444 103.217 120.444 106.838C120.444 110.459 123.379 113.394 127 113.394Z"
        fill={color}
      />
      <path
        d="M187.222 113.394C190.843 113.394 193.778 110.459 193.778 106.838C193.778 103.217 190.843 100.282 187.222 100.282C183.601 100.282 180.666 103.217 180.666 106.838C180.666 110.459 183.601 113.394 187.222 113.394Z"
        fill={color}
      />
      <path
        d="M247.444 113.394C251.065 113.394 254 110.459 254 106.838C254 103.217 251.065 100.282 247.444 100.282C243.823 100.282 240.888 103.217 240.888 106.838C240.888 110.459 243.823 113.394 247.444 113.394Z"
        fill={color}
      />
    </Svg>
  )
}

export default Dots
